import { useState, useEffect, useRef } from "react";

export default function ProductSelect({
  products,
  value,
  onChange,
  disabled,
  placeholder = "Select product…",
}) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    function handleClick(e) {
      if (!rootRef.current) return;
      if (!rootRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  function pickOption(p) {
    onChange(p);
    setOpen(false);
  }

  return (
    <div ref={rootRef} style={{ position: "relative" }}>
      {/* Trigger */}
      <button
        type="button"
        disabled={disabled}
        onClick={() => setOpen(o => !o)}
        style={{
          width: "100%",
          padding: "10px 36px 10px 12px",
          border: "1px solid #ccc",
          borderRadius: 8,
          backgroundColor: disabled ? "#f5f5f5" : "#fff",
          fontSize: 14,
          textAlign: "left",
          cursor: disabled ? "not-allowed" : "pointer",
          boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
        }}
      >
        {value || placeholder}
        <span
          style={{
            position: "absolute",
            right: 12,
            top: "50%",
            transform: "translateY(-50%)",
            fontSize: 16,
            color: "#555",
          }}
        >
          ▼
        </span>
      </button>

      {/* Dropdown */}
      {open && !disabled && (
        <div
          role="listbox"
          style={{
            position: "absolute",
            zIndex: 200,
            left: 0,
            right: 0,
            marginTop: 0,
            maxHeight: 260,
            overflowY: "auto",
            background: "#fff",
            border: "1px solid #ddd",
            borderRadius: 8,
            boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
          }}
        >
          {products.map(p => (
            <div
              key={p}
              role="option"
              aria-selected={value === p}
              onMouseDown={(e) => {
                e.preventDefault();
                pickOption(p);
              }}
              style={{
                padding: "10px 12px",
                cursor: "pointer",
                background: value === p ? "#f1f5f9" : "#fff",
                borderBottom: "1px solid #f5f5f5",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {p}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
